/**
 * intake (反響予約フォーム v4/v5/v6) の公開ルート定義
 *
 * `lib/middleware/route-registry.ts` から static import される。
 *
 * Edge Runtime 制約:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 *
 * 2026-07-03: V6 form (/intake-v6) を追加。
 * PR #7871 で intake-v6 form が新設された際に本 route-config への追加が漏れており、
 * 未認証の来場客が /intake-v6 URL にアクセスすると /login にリダイレクトされる不具合を修正。
 * 🔴 v5/v6 とも API は無い（送信先は v4 と同じ /api/intake-survey-v4）。
 * v5/v6 専用の /api/intake-survey-v5・v6 の route.ts は存在しない。
 *
 * 🔴 '/api/intake-survey'・'/api/intake-survey-v2' は prefix match（下記
 * `pathname === p || pathname.startsWith(p + '/')`）で /verify-lead・/prefill・/list の
 * サブルートも公開する。v1/v2 の POST/GET 本体（route.ts）は
 * INTAKE-SURVEY-V1-V2-DEAD-BROKEN-1（未認証で公開されたまま誰にも使われず必ず500になる
 * 死んだ経路と実測確定・2026-09-13）で削除済みだが、サブルートは稼働中のため
 * このエントリ自体は残す（削除すると /verify-lead・/prefill・/list が認証必須になり壊れる）。
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 */

export const INTAKE_PUBLIC_PATHS = {
  pages: ['/intake-v4', '/intake-v5', '/intake-v6'] as const,
  apis: ['/api/intake-survey', '/api/intake-survey-v2', '/api/intake-survey-v4'] as const,
} as const
